import { customTextBlock, heading, paragraph } from "../../../text/nodes"
import { RoundImageLeftCopyRight as RoundImageLeftCopyRightEditor } from "./round-image-left-copy-right"
import { RoundImageLeftCopyRightSettings } from "./round-image-left-copy-right-settings"
import RoundImageLeftCopyRightPreview from "./round-image-left-copy-right-preview.png"
import { getFont } from "app/regions/blocks/shared/fonts"

export const RoundImageLeftCopyRight = {
  name: "RoundImageLeftCopyRight",
  label: "round image on left, call to action on right",
  EditorComponent: RoundImageLeftCopyRightEditor,
  SettingsComponent: RoundImageLeftCopyRightSettings,
  image: RoundImageLeftCopyRightPreview,
  defaultProperties: {
    backgroundColor: "#f9f9f9",
    headingColor: "#000000",
    textColor: "#4d4d4d",
    image: "",
    alt: "",
    paddingTop: 18,
    paddingRight: 18,
    paddingBottom: 18,
    paddingLeft: 18,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    columnRatio: 35,
    borderColor: "#000000",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    headingFontFamily: getFont("Charter"),
    headingFontWeight: 500,
    textFontFamily: getFont("Verdana"),
    textFontWeight: 400
  },
  defaultChildren: [
    customTextBlock([
      heading("two", "This needs a title"),
      paragraph(
        "Donec sed orci vitae. Morbi ultrices vehicula erat.em ipsum dolor sit amet, consectetur adipi scing elit."
      )
    ])
  ]
}
